module.exports = __webpack_public_path__ + "static/media/productIcon.9f1165d3.svg";